import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/novedad`;
const urlActivityBase = `${process.env.API_URL}/activity/novedad/`;
const readUrl = (url = "") => `${urlBase}/${url}`;

export const fetchNovedades = async (params, forcestats) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);
  if (forcestats) {
    query.set("forcestats", "true");
  }

  let res = await fetch(readUrl(`?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const fetchNovedad = async (itemId) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${itemId}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const fetchNovedadCategories = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl("categories"), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const fetchNovedadActivity = async (itemId) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(urlActivityBase + itemId, {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const postNovedadComment = async (itemId, comment) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`comment`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ itemId, comment }),
  });

  res = await parseJSON(res);

  return res.success;
};

export const fetchNovedadPiAsignable = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`pi_asignable`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const patchNovedadObservations = async (novedadId, observations) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${novedadId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ observations }),
  });

  res = await parseJSON(res);

  return res.success;
};
